import * as React from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

export interface CheckboxProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  // onCheckedChange?: (checked: boolean) => void
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, onChange, ...props }, ref) => {
    return (
      <div className='relative'>
        <input
          type='checkbox'
          className={cn(
            'peer h-5 w-5 shrink-0 rounded-sm border border-gray-300 bg-white appearance-none',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D4A574] focus-visible:ring-offset-2',
            'disabled:cursor-not-allowed disabled:opacity-50',
            'checked:bg-[#D4A574] checked:border-[#D4A574] checked:text-white',
            className
          )}
          ref={ref}
          onChange={onChange}
          {...props}
        />
        <Check className='absolute left-0.5 top-0.5 h-4 w-4 text-white opacity-0 peer-checked:opacity-100 pointer-events-none' />
      </div>
    )
  }
)
Checkbox.displayName = 'Checkbox'

export { Checkbox }
